<style>
.local {
  border-bottom: 1px solid #000000;
}
</style>
<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-8">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="painel.nome" />
        </div>
        <div class="col-md-4">
          <label>Vídeo</label>
          <v-select
            :options="videos"
            :reduce="(videos) => videos.id"
            :label="'titulo'"
            v-model="painel.video"
            class="vselect"
          ></v-select>
        </div>
        <div class="col-md-3">
          <label>Cor do fundo</label>
          <input
            type="color"
            class="form-control"
            v-model="painel.background"
          />
        </div>
        <div class="col-md-3">
          <label>Cor dos cards</label>
          <input type="color" class="form-control" v-model="painel.cor_card" />
        </div>
        <div class="col-md-3">
          <label>Cor primaria</label>
          <input
            type="color"
            class="form-control"
            v-model="painel.cor_primaria"
          />
        </div>
        <div class="col-md-3">
          <label>Cor secundaria</label>
          <input
            type="color"
            class="form-control"
            v-model="painel.cor_secundaria"
          />
        </div>
        <div class="col-md-3">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !painel.relogio }"
            style="cursor: pointer"
          >
            <input type="checkbox" v-model="painel.relogio" class="d-none" />
            Relógio
          </label>
        </div>
        <div class="col-md-3">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !painel.previsao }"
            style="cursor: pointer"
          >
            <input type="checkbox" v-model="painel.previsao" class="d-none" />
            Previsão do tempo
          </label>
        </div>
        <div :class="painel.previsao ? 'col-md-3' : 'd-none'">
          <label>Código do IBGE </label>
          <input type="text" class="form-control" v-model="painel.ibge" />
        </div>
        <div :class="painel.previsao ? 'col-md-3' : 'col-md-6'">
          Logo
          <input type="file" class="form-control" id="logo" @input="fileAdd" />
        </div>
        <div class="col-md-3">
          <label>Arredondamento</label>
          <label class="ml-5">{{ painel.arredondamento }}px</label>
          <input
            type="range"
            v-model="painel.arredondamento"
            class="form-control"
            step="1"
            min="0"
            max="50"
          />
        </div>
        <div class="col-md-3">
          <label>Tamanho da fonte</label>
          <label class="ml-5">{{ painel.fonte }}vh</label>
          <input
            type="range"
            :value="painel.fonte"
            @input="painel.fonte = parseFloat($event.target.value)"
            class="form-control"
            step="1"
            min="5"
            max="30"
          />
        </div>
        <div class="col-md-3">
          <label>Alerta</label>
          <v-select
            :options="alertas"
            :reduce="(alertas) => alertas.id"
            :label="'nome'"
            v-model="painel.alerta"
            class="vselect"
          ></v-select>
        </div>
        <div class="col-md-3">
          <br />
          <label
            class="btn btn-primary w-100"
            v-bind:class="{ disabled: !painel.mostra_pessoa }"
            style="cursor: pointer"
          >
            <input
              type="checkbox"
              v-model="painel.mostra_pessoa"
              class="d-none"
            />
            Nome da {{ configuracao.tipo_pessoa }}
          </label>
        </div>
        <div class="col-md-12">
          <label>
            Mensagem
            <span
              :style="
                painel.mensagem.length > 300
                  ? 'color: red; font-weight: 500;'
                  : ''
              "
            >
              ({{ (painel.mensagem.length - 300) * -1 }})
            </span>
          </label>
          <input
            type="text"
            class="form-control"
            v-model="painel.mensagem"
            maxlength="300"
          />
        </div>
        <div class="col-md-3">
          <label>Velocidade da mensagem</label>
          <label class="ml-5">{{ painel.velocidade_letreiro || 3 }}</label>
          <input
            type="range"
            v-model.number="painel.velocidade_letreiro"
            class="form-control"
            step="1"
            min="1"
            max="20"
          />
        </div>
        <div class="col-md-12 mt-1 row">
          <div class="col-md-12">
            <label>Setores</label>
          </div>
          <div class="col-md-3">
            <button class="btn btn-primary w-100" @click="desmarcar()">
              Desmarcar todos
            </button>
          </div>
          <div class="col-md-3">
            <button class="btn btn-primary w-100" @click="marcar()">
              Marcar Todos
            </button>
          </div>
          <div class="col-md-3">
            <button class="btn btn-primary w-100" @click="inverter()">
              Inverter seleção
            </button>
          </div>
          <div class="col-md-12 mb-2"></div>
          <div
            :class="'mt-1 col-md-' + (setores.length < 5 ? '4' : '2')"
            v-for="setor in setores"
            :key="setor.id"
          >
            <button
              class="btn btn-primary w-100"
              :class="setor.active ? 'opacity-100' : 'opacity-50'"
              @click="inverte(setor)"
            >
              {{ setor.nome }}
            </button>
          </div>
        </div>
        <div class="col-md-12">
          <hr />
        </div>
        <div
          class="col-md-12 mt-1 mb-1 p-1"
          :style="
            'font-family: helvetica; height: 75vh; background: radial-gradient(' +
            painel.background +
            ', #000000); display: flex;flex-wrap: wrap;'
          "
        >
          <div
            class="d-flex justify-content-center align-items-center"
            :style="
              'width: 69%; height: 84%; background:' +
              painel.cor_card +
              '; border-radius:' +
              painel.arredondamento +
              'px; margin-right: 1%; flex-direction: column;'
            "
            v-if="!painel.video"
          >
            <span
              :style="
                'color:' +
                painel.cor_primaria +
                '; font-size: ' +
                painel.fonte * 0.4 +
                'vh;  line-height: ' +
                painel.fonte * 0.4 +
                'vh;'
              "
              >Senha</span
            ><br />
            <span
              :style="
                'color:' +
                painel.cor_secundaria +
                '; font-size: ' +
                painel.fonte +
                'vh; line-height: ' +
                painel.fonte +
                'vh;'
              "
              >A<span :style="'color:' + painel.cor_primaria + ';'"
                >0005</span
              ></span
            ><br />
            <span
              :style="
                'color:' +
                painel.cor_primaria +
                '; font-size: ' +
                painel.fonte * 0.4 +
                'vh;  line-height: ' +
                painel.fonte * 0.4 +
                'vh;'
              "
              >Local</span
            ><br />
            <span
              :style="
                'color:' +
                painel.cor_primaria +
                '; font-size: ' +
                painel.fonte * 0.53 +
                'vh;  line-height: ' +
                painel.fonte * 0.53 +
                'vh;'
              "
              >Guichê 01</span
            ><br />
            <span
              :style="
                'color:' +
                painel.cor_primaria +
                '; font-size: ' +
                painel.fonte * 0.33 +
                'vh;  line-height: ' +
                painel.fonte * 0.33 +
                'vh;'
              "
              v-show="painel.mostra_pessoa"
              >Antônio Carlos Jobim</span
            ><br />
          </div>
          <div
            class="d-flex justify-content-center align-items-center"
            :style="
              'width: 69%; height: 84%; background: #000000; border-radius:' +
              painel.arredondamento +
              'px; margin-right: 1%; flex-direction: column;'
            "
            v-else
          ></div>
          <div
            class="d-flex text-center p-0"
            :style="
              'width: 30%; height: 84%; color: ' +
              painel.cor_primaria +
              '; background:' +
              painel.cor_card +
              '; border-radius:' +
              painel.arredondamento +
              'px; flex-direction: column;'
            "
          >
            <div
              class="p-0 d-flex align-items-center justify-content-center"
              :style="
                'padding: 1vh 0; font-weight: 700; font-size: ' +
                painel.fonte * 0.21 +
                'vh; border-bottom: 2px solid #000; color: ' +
                painel.cor_primaria
              "
            >
              Últimas Chamadas
            </div>

            <div
              v-for="item in [
                { senha: '0005', pessoa: 'Antônio Carlos Jobim' },
                { senha: '0004', pessoa: 'Heitor Vila-Lobos' },
                { senha: '0003', pessoa: 'Mozart C. Guarnieri' },
                { senha: '0002', pessoa: 'Adoniran Barbosa' },
              ]"
              :key="item.senha"
              class="d-flex flex-column align-items-center justify-content-center"
              style="
                flex: 1;
                border-top: 1px solid #000;
                min-height: 0;
                padding: 0.5vh;
              "
            >
              <div
                :style="
                  'color:' +
                  painel.cor_secundaria +
                  '; font-size: ' +
                  painel.fonte * 0.23 +
                  'vh; line-height: ' +
                  painel.fonte * 0.23 +
                  'vh; font-weight: 600;'
                "
              >
                A<span :style="'color:' + painel.cor_primaria">{{
                  item.senha
                }}</span>
              </div>
              <div
                :style="
                  'font-size: ' +
                  painel.fonte * 0.19 +
                  'vh; line-height: ' +
                  painel.fonte * 0.19 +
                  'vh; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%; padding: 0 0.5vh;'
                "
              >
                Guichê 01
              </div>
              <div
                v-show="painel.mostra_pessoa"
                :style="
                  'font-size: ' +
                  painel.fonte * 0.13 +
                  'vh; line-height: ' +
                  painel.fonte * 0.13 +
                  'vh; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%; padding: 0 0.5vh;'
                "
              >
                {{ item.pessoa }}
              </div>
            </div>
          </div>
          <div
            :class="
              painel.relogio
                ? 'd-flex align-items-center justify-content-center'
                : 'd-none'
            "
            :style="
              'border-radius:' +
              painel.arredondamento +
              'px; width: 10%; height: 14%; background: ' +
              painel.cor_card +
              '; margin-top: 1%; flex-direction: column;'
            "
          >
            <span
              :style="'color:' + painel.cor_primaria + '; font-size: 2.5vh;'"
              >01/01/2000</span
            >
            <span
              :style="'color:' + painel.cor_primaria + '; font-size: 2.5vh;'"
              >00:00:00</span
            >
          </div>
          <div
            :class="
              painel.previsao
                ? 'd-flex align-items-center justify-content-center'
                : 'd-none'
            "
            :style="
              'border-radius:' +
              painel.arredondamento +
              'px; width: 19%; height: 14%; background: ' +
              painel.cor_card +
              '; margin-top: 1%; margin-left: ' +
              (painel.relogio ? '1' : '0') +
              '%;'
            "
          >
            <span :style="'color:' + painel.cor_primaria + '; font-size: 3vh;'"
              >Previsão do tempo</span
            >
          </div>
          <div
            class="d-flex align-items-center justify-content-center"
            :style="
              'border-radius:' +
              painel.arredondamento +
              'px; width: ' +
              (100 -
                ((painel.relogio ? 11 : 0) +
                  (painel.previsao ? 20 : 0) +
                  (hasLogo ? 31 : 0))) +
              '%; height: 14%; background: ' +
              painel.cor_card +
              '; margin-top: 1%; margin-left: ' +
              (painel.relogio + painel.previsao ? '1' : '0') +
              '%;'
            "
          >
            <span
              :style="'color:' + painel.cor_primaria + '; font-size: 6vh;'"
              v-if="painel.mensagem && painel.mensagem.length < 50"
            >
              {{ painel.mensagem }}
            </span>
            <span
              :style="'color:' + painel.cor_primaria + '; font-size: 6vh;'"
              v-else
            >
              (Texto)
            </span>
          </div>
          <div
            :class="
              hasLogo
                ? 'd-flex align-items-center justify-content-center'
                : 'd-none'
            "
            :style="
              'border-radius:' +
              painel.arredondamento +
              'px; width: 30%; height: 14%; background: ' +
              painel.cor_card +
              '; margin-top: 1%; margin-left: 1%;'
            "
          >
            <img :src="imageData" style="max-height: 90%; max-width: 98%" />
          </div>
        </div>
        <div class="col-md-12 text-right">
          <hr />
          <router-link to="/paineis" class="btn btn-back mr-1">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-add" @click="save">
            Salvar
            <i class="fa fa-save"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      imageData: null,
      hasLogo: false,
      configuracao: [],
      nome_arquivo: "Sem Arquivo",
      loader: 0,
      painel: {
        background: "#15488a",
        cor_card: "#ffffff",
        cor_primaria: "#15488a",
        cor_secundaria: "#ff0000",
        mostra_pessoa: 0,
        arredondamento: 0,
        mensagem: "",
        velocidade_letreiro: 3,
        ativo: "1",
        fonte: 15,
      },
      setores: [],
      painelsetors: [],
      alertas: [
        {
          id: "alerta_padrao.mp4",
          nome: "Alerta padrão",
        },
        {
          id: "S",
          nome: "Chamada por voz",
        },
      ],
    };
  },
  computed: {},
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("nome", self.painel.nome ? self.painel.nome : "");
      fd.append("video", self.painel.video ? self.painel.video : 0);
      fd.append(
        "background",
        self.painel.background ? self.painel.background : ""
      );
      fd.append("cor_card", self.painel.cor_card ? self.painel.cor_card : "");
      fd.append(
        "cor_primaria",
        self.painel.cor_primaria ? self.painel.cor_primaria : ""
      );
      fd.append(
        "cor_secundaria",
        self.painel.cor_secundaria ? self.painel.cor_secundaria : ""
      );
      fd.append("alerta", self.painel.alerta ? self.painel.alerta : "");
      fd.append("mensagem", self.painel.mensagem ? self.painel.mensagem : "");
      fd.append(
        "arredondamento",
        self.painel.arredondamento ? self.painel.arredondamento : 4
      );
      fd.append("fonte", self.painel.fonte ? self.painel.fonte : 15);
      fd.append("relogio", self.painel.relogio ? 1 : 0);
      fd.append("previsao", self.painel.previsao ? 1 : 0);
      fd.append("ibge", self.painel.ibge ? self.painel.ibge : "");
      fd.append("mostra_pessoa", self.painel.mostra_pessoa ? 1 : 0);
      fd.append(
        "velocidade_letreiro",
        self.painel.velocidade_letreiro ? self.painel.velocidade_letreiro : 3
      );
      fd.append("ativo", 1);
      fd.append("setores", JSON.stringify(self.setores));

      fd.append("_method", "POST");

      let logo = document.getElementById("logo");
      fd.append("logo", logo.files[0] ? logo.files[0] : "");

      if (self.painel.id) {
        fd.append("id", self.painel.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "paineis";

      let fd = self.makeFormData();

      if (self.painel.id) {
        api += "/" + self.painel.id;
      }

      self.$loading(true);

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/paineis");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getPaineis: function (id) {
      const self = this;
      const api = self.$store.state.api + "paineis/" + id;

      axios
        .get(api)
        .then((response) => {
          self.painel = response.data.data[0];
          self.painel.fonte = parseFloat(self.painel.fonte);
          if (!self.painel.fonte || self.painel.fonte < 5)
            self.painel.fonte = 15;
          console.log("[Add] fonte recebida da API:", self.painel.fonte);

          if (self.painel.logo) {
            self.setLogo();
          }

          self.setLoader(30);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSetores: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "setores?orderByAsc=nome&ativo=1&paginated=false";

      return axios
        .get(api)
        .then((response) => {
          self.setores = response.data.data;

          for (let i = 0; i < self.setores.length; i++) {
            // Usa $set para garantir reatividade
            self.$set(self.setores[i], "active", false);
          }
          self.setLoader(25);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getPainelSetores: function (id) {
      const self = this;
      const api =
        self.$store.state.api + `painel_setores/${id}?paginated=false`;

      axios
        .get(api)
        .then((response) => {
          self.painelsetors = response.data.data;

          self.painelsetors.forEach((painelsetor) => {
            let setor = self.setores.find(
              (setor) => setor.id === painelsetor.setor_id
            );

            if (setor) {
              self.$set(setor, "active", true);
            }
          });
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getVideos: function () {
      const self = this;
      const api = self.$store.state.api + "videos?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.videos = response.data.data;

          self.setLoader(10);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getNomeArquivo: function () {
      let video = document.getElementById("video");

      this.nome_arquivo = video.files[0].name;
    },
    inverte: function (setor) {
      // Usa $set para garantir reatividade ao inverter
      this.$set(setor, "active", !setor.active);
    },
    getConfiguracao: function () {
      const self = this;
      const api = self.$store.state.api + "configuracoes/";

      axios
        .get(api)
        .then((response) => {
          self.configuracao = response.data.data[0];
          self.setLoader(5);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    fileAdd: function (event) {
      let logo = document.getElementById("logo");

      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(file);
        this.hasLogo = true;
      } else {
        this.imageData = null;
        this.hasLogo = false;
        self.$message(
          null,
          "Por favor, selecione um arquivo de imagem válido.",
          "error"
        );
      }
    },
    setLogo: function () {
      const self = this;

      self.hasLogo = true;
      self.imageData = self.painel.logo_f;
    },
    marcar: function () {
      const self = this;

      self.setores.forEach((setor) => {
        setor.active = true;
      });

      this.$forceUpdate();
    },
    desmarcar: function () {
      const self = this;

      self.setores.forEach((setor) => {
        setor.active = false;
      });

      this.$forceUpdate();
    },
    inverter: function () {
      const self = this;

      self.setores.forEach((setor) => {
        // Usa $set para garantir reatividade ao inverter todos
        self.$set(setor, "active", !setor.active);
      });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    setTimeout(function () {
      self.setLoader(30);
    }, 300);

    self.getConfiguracao();
    self.getVideos();

    // Carrega os setores primeiro, depois marca os selecionados
    self.getSetores().then(() => {
      if (id) {
        self.getPaineis(id);
        self.getPainelSetores(id);
      } else {
        setTimeout(function () {
          self.setLoader(30);
        }, 300);
      }
    });
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

.opacity-100 {
  opacity: 1;
}

.opacity-50 {
  opacity: 0.5;
}
</style>